<template>
  <div class="knowledge-hero-backround bg-green-500 -mx-6 -mt-6">
    <div class="flex items-center justify-center p-10">
      <Search />
    </div>
  </div>
</template>

<script>
import Search from "@/components/knowledge/Search";
export default {
  name: "Hero",
  components: { Search }
};
</script>

<style>
.knowledge-hero-backround {
  background: var(--knowledge-hero-background);
  background-size: cover;
}
</style>